import React, { useState } from "react";
import "./MysavedReports.css";

const MysavedReports = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => setIsOpen(!isOpen);

    return (
        <div className="mysaved-reports" style={{ position: "relative", opacity: 0.4, pointerEvents: "none" }}>
            <div className="header-container">
                <h1>My Saved Reports</h1>
                <div className="manage-btn-container">
                    <button className="manage-btn" onClick={toggleMenu}>
                        Manage <span className="triangle">&#9660;</span>
                    </button>
                    {isOpen && (
                        <ul className="dropdown-menu">
                            <li className="dropdown-item">Option 1</li>
                            <li className="dropdown-item">Option 2</li>
                            <li className="dropdown-item">Option 3</li>
                        </ul>
                    )}
                </div>
            </div>
            <div className="list-container">
                {[{ name: "Revenue Report", icon: "/task.png" },
                  { name: "Churn Rate Report", icon: "/task.png" }, 
                  { name: "Call Review Report", icon: "/call_end.png" }
                ].map((item, index) => (
                    <div key={index} className="report-item" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', borderRadius: '8px', backgroundColor: 'rgba(246, 244, 255, 1)', marginBottom: '8px' }}>
                        <img 
                            src={item.icon}  
                            alt="report icon" 
                            style={{ width: '20px', height: '20px' }}  
                        />
                        <span className="report-text">{item.name}</span>
                        <img 
                            src="/triangle.png"  
                            alt="see more" 
                            style={{ width: '10px', height: '10px' }}  
                        />
                    </div>
                ))}
            </div>
            {children}
            <div 
                style={{ 
                    position: "absolute", 
                    top: "50%", 
                    left: "50%", 
                    transform: "translate(-50%, -50%)", 
                    fontSize: "40px", 
                    fontWeight: "bold", 
                    color: "rgb(0, 0, 0)", 
                    textAlign: "center", 
                    zIndex: 10
                }}
            >
                Coming Soon
            </div>
        </div>
    );    
};

export default MysavedReports;
